<template>
  <div :class="$style.root">
    <slot />
  </div>
</template>

<script>

export default {
  name: 'Stepper',

  reactiveProvide: {
    name: 'Stepper',
    include: [ 'activeStep' ]
  },

  props: {
    activeStep: Number
  }
}

</script>

<style module>

.root {
  display: flex;
}

.root > * {
  @apply 
    py-2 
    px-4;
}

</style>
